import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../common/Breadcrumbs";
import Icon from "../../../assets/images/brush.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import { axiosInstance, config } from "../config";
import Loader from "../../common/Loader";
import moment from "moment";
import caseStudyBg from "../../../assets/images/bg/case-study-bg.jpg"

const CaseDetail = () => {

    const { slug } = useParams();
    const [Loading , setLoading] = useState(false);
    const [data , setData] = useState([]);
    const [Latest , setLatest] = useState([]);

    const Navigate = useNavigate()

    useEffect(() => {
        setLoading(true)
        axiosInstance.get(`casestudy/${slug}`)
            .then(res => {
                setData(res?.data?.CaseStudy)
                setLatest(res?.data?.latest);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err)
                Navigate(`${config.appUrl}case-studies`);
            })
            .finally(() => {
                setLoading(false)
            })
    },[slug])

    useEffect(() => {
        // Select all tables inside div elements
        const tables = document.querySelectorAll('.desc table');
        if (tables) {
            // Loop through each table and wrap it inside a new div with the 'table-responsive' class
            tables.forEach(table => {
                // Create a new div element
                const wrapperDiv = document.createElement('div');
                wrapperDiv.classList.add('table-responsive');
 
                // Insert the new div before the table
                table.parentNode.insertBefore(wrapperDiv, table);
 
                // Move the table inside the new div
                wrapperDiv.appendChild(table);
            });
        }
    }, [data])


    return (
        <div>
            {Loading && <Loader/>}
            <Breadcrumbs
                title={"Case Study Details"}
                description={
                    "Pronunciation and more common words. If several languages coalesce over the years, sometimes by accident, sometimes on purpose."
                }
                image={caseStudyBg}
            />

            <div class="rs-project-details pt-120 pb-120 md-pt-80 md-pb-80">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-8 md-mb-50 md-pr-15 pr-35">
                            <div class="bs-img mb-5">
                                <img
                                    src={data?.imageUrl}
                                    alt="Case Study Image"
                                    className="w-100 object-fit-cover"
                                />
                            </div>
                            <div class="sec-title2 mb-40">
                                <div class="brush-content mb-8">
                                    <img src={Icon} alt="" />
                                    <span class="sub-text small-text">Case Study Details</span>
                                </div>
                                <div className="my-4 d-flex gap-2">
                                    <div><a className='case-study-date'><i class="bi bi-calendar-week-fill pe-2"></i>{moment(data?.created_at).format("MMMM D, YYYY")}</a></div>
                                    <div><a className='case-study-type'>{data?.type}</a></div>
                                </div>
                                <h2 class="title title2 pb-22">{data?.title}</h2>
                                <div class="desc mb-3" dangerouslySetInnerHTML={{__html:data?.description}}>
                                    
                                </div>
                                {/* <div class="desc mb-3">
                                    Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                                    accusantium doloremque laudantium, totam rem aperiam, eaque
                                    ipsa quae ab illo inventore veritatis et quasi architecto
                                    beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem
                                    quia voluptas sit aspernatur aut odit aut fugit, sed quia
                                    consequuntur magni dolores eos qui ratione voluptatem sequi
                                    nesciunt. Neque porro quisquam est, qui dolorem ipsum quia
                                    dolor sit amet, consectetur, adipisci velit, sed quia non
                                    numquam eius modi tempora incidunt ut labore et dolore magnam
                                    aliquam quaerat voluptatem. Ut enim ad minima veniam, quis
                                    nostrum exercitationem ullam corporis suscipit laboriosam,
                                    nisi ut aliquid ex ea commodi consequatur?
                                </div>
                                <div>
                                    <p>The cleaning services we provide include:</p>
                                    <ul class="listing-style"><li>100% responsive</li><li>99% client satisfaction</li><li>Best business theme 2018</li><li>Duty or the obligations of business</li></ul>
                                </div>
                                <div class="desc mb-3">
                                    In addition, Deloitte employees have used their own company
                                    recognition schemes to acknowledge the excellent performance
                                    of Mitie colleagues. These awards demonstrate that for many
                                    Deloitte employees our cleaning teams are not simply people
                                    who turn up and clean, rather, they are thought of as
                                    essential members of the Deloitte team.
                                </div> */}
                            </div>
                        </div>
                        <div class="col-lg-4 pl-40 md-pl-15">
                            <div class="project-information">
                                <div class="project-title">
                                    <h3 class="title">Case Study Archive</h3>
                                </div>
                                <div class="project-content mb-22">
                                    <h4 class="title">Services</h4>
                                    <div class="description">{data?.service}</div>
                                </div>
                                <div class="project-content mb-22">
                                    <h4 class="title">Customer</h4>
                                    <div class="description">{data?.customer}</div>
                                </div>
                                <div class="project-content mb-22">
                                    <h4 class="title">Completed Date</h4>
                                    <div class="description">{moment(data?.date).format("MMMM D , YYYY")}</div>
                                </div>
                                <div class="project-content">
                                    <h4 class="title">Location</h4>
                                    <div class="description">{data?.location}</div>
                                </div>
                            </div>
                            <div className="rs-inner-blog mt-5">
                                <div class="widget-area">
                                    <div class="recent-posts mb-50">
                                        <div class="widget-title">
                                            <h3 class="title">Recent Case Study</h3>
                                        </div>
                                        {Latest?.length > 0 && Latest?.slice(0,3)?.map((item) => (
                                            <Link to={`${config.appUrl}case-study/${item.slug}`} class="recent-post-widget overflow-hidden">
                                                <div class="post-img ">
                                                    <a>
                                                        <img
                                                            src={item?.imageUrl}
                                                            alt=""
                                                            className="w-100 object-fit-cover"
                                                        />
                                                    </a>
                                                </div>
                                                <div class="post-desc">
                                                    <a>
                                                        {item?.title}
                                                    </a>
                                                    <span class="date-post">
                                                        <i class="bi bi-calendar-event"></i>{moment(item?.createdAt).format("MMMM D, YYYY")}{" "}
                                                    </span>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CaseDetail;
